// src/feathersClient.js
import feathers from "@feathersjs/feathers";
import socketio from "@feathersjs/socketio-client";
import io from "socket.io-client";
import auth from "@feathersjs/authentication-client";
import configureStore from "./config/configureStore";
import { setCircularLoading } from "./reducers/UiReducer";
import { setUserAuthenticated, setUserData } from "./reducers/UserReducer";
import { notifyPanel } from "./reducers/NotifierReducer";
import { handleError } from "./reducers/ErrorReducer";
const { store } = configureStore;

const client = feathers();

client.configure(
  socketio(
    io(window.__RUNTIME_CONFIG__.REACT_APP_API_URL, {
      transports: ["websocket", "polling"],
      timeout: 20000,
    })
  )
);

client.configure(auth({ storageKey: "auth" }));

// GLOBAL HOOKS
client.hooks({
  before: {
    all: [
      async (context) => {
        store.dispatch(setCircularLoading(true));
        return context;
      },
    ],
  },
  after: {
    all: [
      async (context) => {
        store.dispatch(setCircularLoading(false));
        return context;
      },
    ],
  },
  error: [
    async (context) => {
      const { error } = context;
      const dispatch = store.dispatch;

      store.dispatch(setCircularLoading(false));

      if (error.code === 401) {
        dispatch(setUserAuthenticated(false));
        dispatch(setUserData(null));
      } else if (error.code === 408) {
        dispatch(
          notifyPanel(
            {
              title: "Network Error",
              message: "Please check your connection.",
              level: "error",
            },
            "error"
          )
        );
      } else if (!error.context?.skipNotification) {
        // Skip generic notification if handled by asyncThunkWrapper
        dispatch(
          notifyPanel({ title: "Error", message: error.message }, "error")
        );
      }

      dispatch(handleError(error));

      throw error; // important: rethrow for local try/catch to work if needed
    },
  ],
});

export default client;
